import PercentageFormat from '€lib/strings/percentageFormat';

export default function calculatePercentage(a: number, b: number): string {
    if (a < 1) {
        return '';
    }
    let percent: number;
    if (b !== 0) {
        if (a !== 0) {
            percent = ((b - a) / a) * 100;
        } else {
            percent = b * 100;
        }
    } else {
        percent = -a * 100;
    }

    if (percent < 1) {
        return '';
    }

    return `${percent > 0 ? '+' : '-'}${PercentageFormat(percent)}`;
}
